import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Collapsible } from "@/components/ui";

const ROWS: { name: string; meaning: string }[] = [
  {
    name: "player",
    meaning: "The player's email, alias or internal ID. No match: the link opens at the account level.",
  },
  { name: "fan", meaning: "A SocialCoach Fan ID, when your CRM already has it. Checked first." },
  { name: "client_id", meaning: "Your CRM's ID for the client. Finds the Fan, and is saved on a new one." },
  { name: "client_email", meaning: "The client's email. Finds a Fan you already have, and is saved on a new one." },
  { name: "client_type", meaning: "customer (the default) or partner." },
  { name: "source", meaning: "SC (the default) or TE when the link comes from TotalExpert." },
  { name: "lang", meaning: "A language code such as es. Opens the form in that language when the form supports it." },
  { name: "test", meaning: "1 marks the Fan and link as tests." },
  {
    name: "utm_source, utm_medium, utm_campaign, utm_term, utm_content",
    meaning: "Campaign tracking. Saved on the form link and never passed on to the form.",
  },
];

export function RouteReference() {
  return (
    <Collapsible className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm">
      <Collapsible.Trigger className="group flex w-full items-center justify-between text-base font-semibold text-slate-800 cursor-pointer">
        All parameters
        <ChevronDown className="size-4 text-slate-400 transition-transform group-data-[panel-open]:rotate-180" />
      </Collapsible.Trigger>
      <Collapsible.Content className="mt-4 flex flex-col gap-3">
        <table className="w-full text-sm">
          <tbody className="divide-y divide-slate-100">
            {ROWS.map(row => (
              <tr key={row.name}>
                <td className="py-2 pr-4 align-top font-mono text-xs text-slate-800 w-1/3 break-words">{row.name}</td>
                <td className="py-2 text-slate-600">{row.meaning}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-xs text-slate-500 leading-relaxed">
          Unknown parameters are ignored. The email in the link is used once to find or create the Fan; the link the
          client lands on carries none of it. Names and phone numbers are never part of a route.
        </p>
      </Collapsible.Content>
    </Collapsible>
  );
}
